import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../utils/api"
import ButtonComponent from "../components/ButtonComponent";
import { useNotify } from "../components/NotificationComponent";
import { UserContext } from "../context/UserContext";


export default function RegisterPage() {
  const navigate = useNavigate()
  const { userInfo } = useContext(UserContext)
  const [msg, setMsg] = useState("");
  const [data, setData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: ''
  })
  const [loading, setLoading] = useState(false)
  const {notify} = useNotify()

  useEffect(()=>{
    if(userInfo?.access){
      navigate('/')
    }
  },[userInfo])

  const changeHandler = (key, value) => {
    setData({...data, [key]: value})
  }

  const submitHandler =async () => {
    try {
      for(const key of Object.keys(data)) {
        if(data[key].length === 0){
          return notify(`All fields are required.`)
        }
      }
      if(data.password !== data.confirmPassword) {
        return notify("Passwords do not match")
      }
      setLoading(true)

      const res = await apiPost("register/", data);
      setLoading(false);
    } catch (err) {
      notify(err.response.data.detail || err.message)
      setMsg(err.response?.data?.detail || "Registration failed");
      setLoading(false);
    }
  }

  return (
    <div className  ="bg-gray-50 min-h-screen font-sans px-5 py-10">
      <motion.section
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="p-6 md:p-16 text-center"
      >
        <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">
          Create Your Account
        </h2>
        <p className="text-gray-600 text-base md:text-lg max-w-xl mx-auto">
          Sign up to get started with AdMentorAI and begin optimizing your ad strategy with AI.
        </p>
      </motion.section>

      <motion.section
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="py-12 px-4 md:px-16"
        >
        <div className="max-w-md mx-auto bg-white p-8 rounded-xl shadow-md">
          <div className="space-y-6">
            <div>
              <label className="block mb-1 font-medium text-gray-700">Full Name</label>
              <input value={data.fullName} onChange={(e)=>changeHandler('fullName', e.target.value)} type="text" placeholder="John Doe" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">Email</label>
              <input value={data.email} onChange={(e)=>changeHandler('email', e.target.value)} type="email" placeholder="you@example.com" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">Password</label>
              <input value={data.password} onChange={(e)=>changeHandler('password', e.target.value)} type="password" placeholder="Create a password" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700">Confirm Password</label>
              <input value={data.confirmPassword} onChange={(e)=>changeHandler('confirmPassword', e.target.value)} type="password" placeholder="Re-type password" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>
          
            <ButtonComponent loading={loading} title='Register' onClick={submitHandler} />
            <p className="text-sm text-center font-medium text-red-600 mt-4">{msg}</p>
            <p className="text-sm text-gray-500 text-center">Already have an account? <span className="text-blue-600 cursor-pointer hover:underline" onClick={()=>navigate('/login')}>Log in</span></p>
          </div>
        </div>
      </motion.section>

    </div>
  );
  }